import React from 'react';
import { SvgIcon } from '@material-ui/core';

const User = props => (
    <SvgIcon shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="nonzero" clipRule="evenodd" viewBox="0 0 10240 10240" {...props}>
	<path id="curve1" d="M8320 8470c0,810 -1920,1130 -3200,1130 -1280,0 -3200,-320 -3200,-1129 0,-1760 582,-2029 1663,-2835 445,281 972,444 1537,444 565,0 1092,-163 1537,-444 1082,807 1663,1074 1663,2834z"/>
	<path id="curve0" d="M5120 640c1414,0 2560,1146 2560,2560 0,1414 -1146,2560 -2560,2560 -1414,0 -2560,-1146 -2560,-2560 0,-1414 1146,-2560 2560,-2560z"/>
    </SvgIcon>
);
export default User;

